const setCookie = (name: string, value: any, time: number): void => {
  const date = new Date()
  date.setTime(date.getTime() + time)
  const expires = `expires=${date.toUTCString()}`
  document.cookie = `${name}=${value}; ${expires}; path=/`
}

export default setCookie
